// extracted by mini-css-extract-plugin
module.exports = {"mobileNav":"470px","layoutMain":"main_layoutMain__29Prp","content":"main_content__3sltW"};